import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';
import { parseErrorArrayAndThrowMsg } from 'api/utils';

const DataApiUrl = dataApiUrl();

const Users = () => {
  const getAll = () =>
    AuthAxios.get(`${DataApiUrl}/users`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getMe = () =>
    AuthAxios.get(`${DataApiUrl}/users/me`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getByEmail = email =>
    AuthAxios.get(`${DataApiUrl}/users`, {
      params: { email: encodeURIComponent(email) },
    })
      .then(res => res.data.data[0])
      .catch(err => {
        throw err.response;
      });

  const lookupByEmails = emails =>
    AuthAxios.post(`${DataApiUrl}/admin/users/lookup-by-emails`, { emails })
      .then(res => {
        return res.data;
      })
      .catch(err => {
        throw err.response;
      });

  const lookupByEmailsCsv = emails =>
    AuthAxios.post(`${DataApiUrl}/admin/users/lookup-by-emails/csv`, { emails })
      .then(res => {
        const blob = new Blob([res.data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'users.csv'; // File name
        document.body.appendChild(a);
        a.click();

        // Clean up
        a.remove();
        window.URL.revokeObjectURL(url);
      })
      .catch(err => {
        throw err.response;
      });

  const updateUser = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/users/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const invite = id =>
    AuthAxios.post(`${DataApiUrl}/users/${id}/invite`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const changePassword = (user_id, redirect_url) =>
    AuthAxios.post(`${DataApiUrl}/users/changePassword`, {
      user_id: user_id,
      redirect_url: redirect_url,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const actAsUser = (userId, targetUserId) =>
    AuthAxios.post(`${DataApiUrl}/admin/users/${userId}/actAs/${targetUserId}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const deleteUser = async userId => {
    const res = await AuthAxios.delete(`${DataApiUrl}/admin/users/${userId}`);
    return res.data.data;
  };

  const updateUserEmail = (userId, newEmail) =>
    AuthAxios.patch(`${DataApiUrl}/users/${userId}/changeEmail`, { newEmail })
      .then(res => res.data.data)
      .catch(err => {
        let message = 'Updating user email';
        if (err?.response?.data?.status === 409) {
          message = 'This email address is already associated with another user';
        }
        parseErrorArrayAndThrowMsg(message)(err);
      });

  const verifyKyc = async (userId, verify = false) => {
    const res = await AuthAxios.post(`${DataApiUrl}/admin/users/${userId}/verifyKyc`, { verify });
    return res.data.data;
  };

  return {
    getAll,
    getMe,
    getByEmail,
    updateUser,
    invite,
    changePassword,
    deleteUser,
    updateUserEmail,
    actAsUser,
    verifyKyc,
    lookupByEmails,
    lookupByEmailsCsv,
  };
};

export default Users;
